import { render } from "./ContactAvatar.vue?vue&type=template&id=291fbf3b&scoped=true&ts=true"
import script from "./ContactAvatar.vue?vue&type=script&lang=ts"
export * from "./ContactAvatar.vue?vue&type=script&lang=ts"

import "./ContactAvatar.vue?vue&type=style&index=0&id=291fbf3b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291fbf3b"]])

export default __exports__